// Modules
import { createAction, props } from '@ngrx/store';

// Interfaces
import {
  IAccidentList,
  IAccidentsListRequest,
} from '@accidents/shared/interfaces/accidents';
import { ISortingAndFilteringCriteria } from '@accidents/shared/interfaces/ship-accidents';

// ----------- General Actions -----------
// ---------------------------------------
export const reset = createAction('[List Accidents] - Reset');

export const getAccidentsListRequested = createAction(
  '[List Accidents] - Get Accidents List Requested',
  props<{ payload: IAccidentsListRequest }>()
);

export const getAccidentsListResponse = createAction(
  '[List Accidents] - Get Accidents List Response',
  props<{ payload: IAccidentList }>()
);

export const saveNewSortingAndFilteringCriteria = createAction(
  '[List Accidents] - Save new sorting and filtering criteria',
  props<{ payload: ISortingAndFilteringCriteria }>()
);
